/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-expressions */
import React from 'react';
import axios from 'axios';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { throttle } from 'throttle-debounce';
import setOptions from './setOptions';
import globalOptions from './globalOptions';
import mobileGlobalOptions from './mobileGlobalOptions';
import Realtime from './realtime/index';

require('highcharts/indicators/indicators')(Highcharts);
require('highcharts/indicators/volume-by-price')(Highcharts);
require('highcharts/indicators/ichimoku-kinko-hyo')(Highcharts);
require('highcharts/modules/annotations-advanced')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/annotations')(Highcharts);
require('highcharts/modules/drag-panes')(Highcharts);
require('highcharts/modules/stock-tools')(Highcharts);

Highcharts.setOptions(setOptions);

class WebChartReact extends React.Component {
    constructor(props) {
        super(props);

        this.Highcharts = Highcharts;

        this.state = {
            code: this.props.code || 'D0011001',  // KOSPI
            candles: [],
            period: this.props.period || 'days',
            unit: this.props.unit || null
        };

        this.highchartsOptions = {
            yAxis: [
                {
                    id: 'main-yaxis',
                    labels: {
                        align: 'left',
                        x: 5,
                        format: '{value:,.0f}'
                    },
                    lineWidth: 1,
                    gridLineWidth: this.props.isMobile ? 1 : 0,
                    crosshair: {
                        snap: false,
                        label: {
                            enabled: true,
                            format: '{value:,.0f}'
                        }
                    },
                    height: '75%',
                },
                {
                    id: 'volume-yaxis',
                    labels: {
                        align: 'left',
                        x: 5,
                        formatter: function () {
                            if (this.value >= 1000000) {
                                return (this.value / 1000).toLocaleString() + 'k';
                            }
                            else if (this.value >= 1000000000) {
                                return (this.value / 1000000).toLocaleString() + 'm';
                            }
                            return this.value.toLocaleString();
                        }
                    },
                    lineWidth: 1,
                    gridLineWidth: this.props.isMobile ? 1 : 0,
                    offset: 0,
                    top: '75%',
                    height: '25%'
                }
            ],
            series: [
                {
                    name: '메인지표',
                    id: 'main',
                    type: 'candlestick',
                    pointPadding: 0,
                    events: {
                        mouseOut: function () {
                            this.chart.tooltip.hide();
                        }
                    }
                },
                {
                    name: '거래량',
                    id: 'volume',
                    type: 'column',
                    yAxis: 'volume-yaxis'
                }
            ]
        };

        if (this.props.highchartsOptions !== undefined) {
            if (Array.isArray(this.props.highchartsOptions.yAxis)) {
                this.highchartsOptions.yAxis = this.highchartsOptions.yAxis.concat(this.props.highchartsOptions.yAxis);
            }

            if (Array.isArray(this.props.highchartsOptions.series)) {
                this.highchartsOptions.series = this.highchartsOptions.series.concat(this.props.highchartsOptions.series);
            }
        }

        this.riseColor = this.props.colors && this.props.colors.rise || 'rgb(242, 55, 67)';
        this.fallColor = this.props.colors && this.props.colors.fall || 'rgb(41, 126, 228)';
        this.evenColor = this.props.colors && this.props.colors.even || this.riseColor;

        if (this.props.isMobile) {
            this.highchartsOptions = {
                ...mobileGlobalOptions(Highcharts, this.props.globalOptions, {riseColor: this.riseColor, fallColor: this.fallColor}),
                ...this.highchartsOptions
            }
        } else {
            this.highchartsOptions = {
                ...globalOptions(Highcharts, this.props.globalOptions, {riseColor: this.riseColor, fallColor: this.fallColor}),
                ...this.highchartsOptions
            }
        }

        this.candleUrl = `${this.props.api.baseUrl}${this.props.api.candlePath}`;
        this.lastCandleTime;
        this.quoteBuffer = [];
        this.dateDivLines = [];

        this.windowResizeEvtThrottle = throttle(1000, function () {
            if (this.reflow === undefined) return;

            this.reflow();
        });

        this.windowResizeEvtFn;

        this.defaultLoadCandlesCount = this.props.defaultLoadCandlesCount || 300;
        this.defaultShowingCandlesCount = this.props.defaultShowingCandlesCount || 150;

        this.quoteThrottle = throttle(750, () => {
            if (this.chartComponent === undefined || this.chartComponent.current === undefined || this.chartComponent.current.chart === undefined) {
                return;
            }

            let quote;
            while (quote = this.quoteBuffer.pop()) {
                this._receiveQuotes(this, quote);
            }
        });

        this.chartComponent = new React.createRef();
    };


    componentDidMount() {
        // 세로 길이 기본값이 400px이라 100%로 강제 지정하여 상위 객체 사이즈와 일치하도록 변경
        this.chartComponent.current.container.current.style.height = '100%';
        this.chartComponent.current.container.current.style.width = '100%';
        this.chartComponent.current.chart.reflow();

        this.chartComponent.current.chart.period = this.state.period;
        this.chartComponent.current.chart.unit = this.state.unit;

        this.windowResizeEvtFn = () => {
            this.windowResizeEvtThrottle();
        };

        window.addEventListener('resize', this.windowResizeEvtFn);

        let self = this;

        this.chartComponent.current.chart.get('main-xaxis').update({
            events: {
                afterSetExtremes: function (e) {
                    if (!e.target.eventArgs || !['zoom', 'pan', 'navigator'].includes(e.target.eventArgs.trigger)) {
                        return;
                    }

                    if ((e.dataMin === e.min || e.min <= 0) && !this.chart.loadingShown) {
                        self.getPrevCandles();
                    }
                }
            }
        });

        this._getCandles();
    };

    componentDidUpdate(prevProps, prevState) {
        let isRemoveAnnotaions = true

        if (prevProps.code !== this.props.code) {
            this.setState({code: this.props.code});
        }

        if (prevProps.period !== this.props.period) {
            this.setState({period: this.props.period});
        }

        if (prevProps.unit !== this.props.unit) {
            this.setState({unit: this.props.unit});
        }

        if (prevProps.quote !== this.props.quote) {
            isRemoveAnnotaions = false
            this.insertQuotes(this.props.quote);
        }

        if (isRemoveAnnotaions) {
            this.removeAnnotations()
        }

        if (prevProps.reflow !== this.props.reflow) {
            this.reflow();
        }

        if (prevProps.updateDivLines !== this.props.updateDivLines) {
            this.updateDivLines();
        }

        if (prevState.code !== this.state.code) {
            this._getCandles(true);
        }

        if (prevState.period !== this.state.period ||
            prevState.unit !== this.state.unit) {
                this.chartComponent.current.chart.period = this.state.period;
                this.chartComponent.current.chart.unit = this.state.unit;

                this._getCandles();
        }

        if (prevState.candles !== this.state.candles) {
            let chart = this.chartComponent.current.chart;
            if (!chart) return;

            chart.dateLabels = this.state.candles.map(candle => Date.parse(candle.candleTime.replace(/-/g, '/').replace(/[a-z]+/gi, ' ').replace(/.[0-9]$/g, '')));

            chart.get('main').setData(
                this.state.candles.map((candle, i) => [
                    i,
                    candle.openingPrice,
                    candle.highPrice,
                    candle.lowPrice,
                    candle.tradePrice
                ]),
                false
            );

            this.updateDivLines();
            chart.redraw();

            let startX, endX;

            // 첫 로드시 봉 개수 조절
            if (this.state.candles.length <= this.defaultLoadCandlesCount) {
                const showingCandlesCount = this.defaultShowingCandlesCount;

                startX = this.state.candles.length > showingCandlesCount ? this.state.candles.length - showingCandlesCount : 0;
                endX = this.state.candles.length - 1;

                if (typeof this.props.initCandlesHandler === 'function') {
                    this.props.initCandlesHandler(this.state.candles);
                }
            } else {
                // 이전 데이터 불러오는 경우에는 현재 위치 유지
                let prevExtremes = chart.get('main-xaxis').getExtremes();
                let addedCount = this.state.candles.length - prevState.candles.length;

                startX = prevExtremes.min + addedCount;
                endX = prevExtremes.max + addedCount;

                if (typeof this.props.updateCandlesHandler === 'function') {
                    this.props.updateCandlesHandler(addedCount, this.state.candles);
                }
            }

            this._setExtremes(startX, endX);
            chart.hideLoading();
        }
    };

    componentWillUnmount() {
        this.quoteThrottle.cancel();
        window.removeEventListener('resize', this.windowResizeEvtFn);
    }

    removeCustomSectionBand() {
        if (typeof this.props.removeCustomBandId === 'function') {
            this.props.removeCustomBandId()
        }
    }

    _getSeperate() {
        let sep;

        switch(this.state.period) {
            case 'months':
                // 일단 근사치
                sep = 1000 * 60 * 60 * 24 * 30;
                break;
            case 'weeks':
                // 이것도 일단 근사치
                sep = 1000 * 60 * 60 * 24 * 7;
                break;
            case 'days':
                sep = 1000 * 60 * 60 * 24;
                break;
            case 'minutes':
                sep = 1000 * 60 * this.state.unit;
                break;
            default:
                sep = 1000 * 60 * 60 * 24;  // 없으면 일봉으로 잡는다
        }

        return sep;
    };

    updateDivLines() {
        const chart = this.chartComponent.current.chart;

        if (!chart || !chart.dateLabels) return;

      if (typeof this.props.stockPrice=== 'number') {
        const yAxis = chart.get('main-yaxis');
        yAxis.removePlotLine('stockPrice')
        yAxis.addPlotLine(
          {
            value: this.props.stockPrice,
            color: '#FF0000',
            width: 1,
            dashStyle: 'Solid',
            id: 'stockPrice',
            text: '주가',
            zIndex: 500,
            label: {
              text: `손절가 ${this.props.stockPrice.toLocaleString()}`, // README: 매매전략 기준가  텍스트가 필요할때 주석 해제
              align: 'left',
              x: 5,
              y: -5,
              style: {
                color: '#000',
                fontWeight: 'bold',
                fontSize: '16px',
              } }
          }
        )
      }

        const xAxis = chart.get('main-xaxis');
        const showingCandlesCount = (xAxis.max - xAxis.min) || this.defaultShowingCandlesCount;

        let oldDivLine;
        while (oldDivLine = this.dateDivLines.pop()) {
            xAxis.removePlotLine(oldDivLine);
        }

        let prevYear, prevMonth, prevDay, prevHour;
        chart.dateLabels.forEach((date, i) => {
            date = new Date(date);

            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const day = ('0' + date.getDate()).slice(-2);
            const hour = ('0' + date.getHours()).slice(-2);
            const minute = ('0' + date.getMinutes()).slice(-2);

            const id = `dateline-${year}-${month}-${day}-${hour}-${minute}`;

            let text, showDivLine = false, isBold = true;

            if (prevYear !== year) {
                text = year;
                showDivLine = true;
            } else {
                switch (this.props.period) {
                    case 'months':
                        break;
                    case 'weeks':
                        if (showingCandlesCount >= 150 && month % 3) {
                            break;
                        }

                        if (showingCandlesCount >= 300) {
                            break;
                        }
                    case 'days':
                        if (prevMonth === month) {
                            break;
                        }

                        if (showingCandlesCount >= 1200) {
                            break;
                        }

                        if (showingCandlesCount >= 500 && month % 3) {
                            break;
                        }

                        text = month;
                        isBold = false;

                        break;
                    case 'minutes':
                        if (prevDay !== day) {
                            text = `${month}/${day}`;
                            showDivLine = true;

                            break;
                        }

                        if (this.props.unit >= 15 ||
                            (this.props.unit >= 10 && showingCandlesCount >= 300) ||
                            (this.props.unit >= 3 && showingCandlesCount >= 500) ||
                            showingCandlesCount >= 1500) {
                            break;
                        }

                        if (prevHour !== hour) {
                            text = `${hour}`;
                            isBold = false;
                        }

                        break;
                }
            }

            if (text === undefined) return;

            prevYear = year;
            prevMonth = month;
            prevDay = day;
            prevHour = hour;

            xAxis.addPlotLine({
                id: id,
                value: i,
                width: 1,
                color: showDivLine ? '#aaa' : '#fff',
                label: {
                    text: text,
                    rotation: 0,
                    verticalAlign: 'bottom',
                    x: -20,
                    y: chart.plotHeight - chart.get('main-yaxis').height + 18,
                    useHTML: true,
                    style: {
                        backgroundColor: '#fff',
                        fontWeight: isBold ? 'bold' : undefined,
                        textAlign: 'center',
                        zIndex: isBold ? 1 : 0
                    }
                }
            }, false);

            this.dateDivLines.push(id);
        });
    }

    _getCandles(isForce) {
        if (this.chartComponent.current.chart.loadingShown && !isForce) return;
        this.chartComponent.current.chart.showLoading();

        axios({
            method: 'GET',
            url: `${this.candleUrl}/${this.state.period}${this.state.period === 'minutes' ? `/${this.state.unit}` : ''}`,
            params: {
                code: this.state.code,
                count: this.defaultLoadCandlesCount
            }
        }).then(res => {
            if (!res || !res.data || res.data.length === 0) {
                this.chartComponent.current.chart.hideLoading();
                return;
            }

            if (res.data.error) {
                this.chartComponent.current.chart.hideLoading();
                throw({response: res});
            }

            let firstIdxCandle = res.data[0];

            if (this.state.code !== firstIdxCandle.code) return;

            let state = {candles: res.data.reverse()};
            if (res.data.length > 0) {
                this.lastCandleTime = state.candles[0].candleTime;
            }

            this.setState(state);
        }).catch(err => {
            let isApiErr = err.response && err.response.data && err.response.data.error ? false : true;

            let errMsg = isApiErr ?
                         (err.response && err.response.status) || '' :
                         `\n\n------------\n${err.response.status}: ${err.response.data.error}\n${err.response.data.message}`;

            window.alert(`차트 데이터를 불러오지 못했습니다.\n문제가 반복되면 고객센터로 문의해 주시기 바랍니다.${errMsg}`);

            if (isApiErr) {
                this.setState({candles: []});
            }
        });
    };

    getPrevCandles() {
        if (this.chartComponent.current.chart.loadingShown) return;
        this.chartComponent.current.chart.showLoading();

        axios({
            method: 'GET',
            url: `${this.candleUrl}/${this.state.period}${this.state.period === 'minutes' ? `/${this.state.unit}` : ''}`,
            params: {
                code: this.state.code,
                count: 200,
                to: this.lastCandleTime
            }
        }).then(res => {
            if (!res || !res.data || res.data.length === 0) {
                this.chartComponent.current.chart.hideLoading();
                return;
            }
            if (res.data.error) throw({response: res});

            let state = {candles: [...res.data.reverse(), ...this.state.candles]};
            if (res.data.length > 0) {
                this.lastCandleTime = state.candles[0].candleTime;
            }

            this.setState(state);
        }).catch(err => {
            let isApiErr = err.response && err.response.data && err.response.data.error ? false : true;

            let errMsg = isApiErr ?
                         (err.response && err.response.status) || '' :
                         `\n\n------------\n${err.response.status}: ${err.response.data.error}\n${err.response.data.message}`;

            window.alert(`차트 데이터를 불러오지 못했습니다.\n문제가 반복되면 고객센터로 문의해 주시기 바랍니다.${errMsg}`);
            this.chartComponent.current.chart.hideLoading();
        });
    };

    _setExtremes(start, end) {
        let extremes = this.chartComponent.current.chart.get('main-xaxis');
        let dataMin = extremes.dataMin;
        if (start < dataMin) start = dataMin;

        this.chartComponent.current.chart.get('main-xaxis').setExtremes(start, end);

        if (start === dataMin) {
            this.getPrevCandles();

            return;
        }

        this.updateDivLines();
    };

    _receiveQuotes(self, quote) {
        // 수신받은 종목이 현재 차트에 표시되고 있는 종목인지 체크
        if (self.state.code !== quote.code) return;
        if (quote.streamType !== 'REALTIME') return;

        let currentChart = self.chartComponent.current.chart;
        let mainSeries = currentChart.get('main');
        let volumeSeries = currentChart.get('volume');

        let candleData = mainSeries.userOptions.data;
        let volumeData = volumeSeries.userOptions.data;

        if (candleData.length === 0) return;

        let lastCandlePointTimestamp = currentChart.dateLabels[currentChart.dateLabels.length - 1];

        let sep = this._getSeperate();

        if (this.state.period !== 'minutes') {
            lastCandlePointTimestamp += 1000 * 60 * 60 * 9;
        }

        if (Math.floor(lastCandlePointTimestamp / sep) < Math.floor(quote.timestamp / sep)) {
            mainSeries.setData([...mainSeries.userOptions.data, [mainSeries.userOptions.data.length, quote.tradePrice, quote.tradePrice, quote.tradePrice, quote.tradePrice]]);
            volumeSeries.setData([...volumeSeries.userOptions.data, {
                x: volumeSeries.userOptions.data.length,
                y: quote.tradeVolume,
                color: quote.openingPrice < quote.tradePrice ? this.riseColor : quote.openingPrice > quote.tradePrice ? this.fallColor : this.evenColor
            }]);
            currentChart.dateLabels.push(quote.timestamp);

            let extremes = currentChart.get('main-xaxis').getExtremes();

            if (extremes.dataMax - 1 === extremes.userMax) {
                this._setExtremes(extremes.min + 1, extremes.max + 1);
            }

            return;
        }

        let lastCandleData = candleData[candleData.length - 1];

        lastCandleData[2] = Math.max(lastCandleData[2], quote.tradePrice);
        lastCandleData[3] = Math.min(lastCandleData[3], quote.tradePrice);
        lastCandleData[4] = quote.tradePrice;
        mainSeries.setData(candleData);

        if (volumeData.length > 0) {
            let lastVolumeData = volumeData[volumeData.length - 1];

            if (Array.isArray(lastVolumeData)) {
                lastVolumeData = {
                    x: lastVolumeData[0],
                    y: lastVolumeData[1] + quote.tradeVolume,
                    color: lastCandleData[1] < lastCandleData[4] ? this.riseColor : lastCandleData[1] > lastCandleData[4] ? this.fallColor : this.evenColor
                }
            } else {
                lastVolumeData.y = lastVolumeData.y + quote.tradeVolume;
                lastVolumeData.color = lastCandleData[1] < lastCandleData[4] ? this.riseColor : lastCandleData[1] > lastCandleData[4] ? this.fallColor : this.evenColor
            }
            volumeSeries.setData(volumeData);
        }

        if (typeof this._updateCatchedStocks === 'function') {
            this._updateCatchedStocks(quote.tradePrice);
        }
    };

    insertQuotes(quote) {
        if (quote.code !== this.state.code) return;

        let sep = this._getSeperate();

        if (this.quoteBuffer.length > 0) {
            let lastPoint = this.quoteBuffer[this.quoteBuffer.length - 1];

            let lastCandlePointTimestamp = lastPoint.timestamp;

            if (this.state.period !== 'minutes') {
                lastCandlePointTimestamp += 1000 * 60 * 60 * 9;
            }

            if (Math.floor(lastCandlePointTimestamp / sep) < Math.floor(quote.timestamp / sep)) {
                this.quoteBuffer.push(quote);
            } else {
                lastPoint.highPrice = Math.max(lastPoint.highPrice, quote.tradePrice);
                lastPoint.lowPrice = Math.min(lastPoint.lowPrice, quote.tradePrice);
                lastPoint.tradePrice = quote.tradePrice;
                lastPoint.tradeVolume = lastPoint.tradeVolume + quote.tradeVolume;
            }
        } else {
            this.quoteBuffer.push(quote);
        }

        this.quoteThrottle();
    };

    setSize(width, height) {
        this.chartComponent.current.chart.setSize(width, height);
    };

    reflow() {
        this.chartComponent.current.chart.reflow();
        this.updateDivLines();
    };

    removeAnnotations() {
        document.querySelectorAll('.highcharts-annotation').forEach(elem => elem.remove())
    }

    removeRecentAnnotation() {
        const elems = document.querySelectorAll('.highcharts-annotation')
        const last = elems[elems.length - 1]

        if(!last) return

        last.remove()
    }

    zoomIn() {
        let chart = this.chartComponent.current.chart;
        let mainSeries = chart.get('main');
        let points = mainSeries.points;
        let firstPointIndex = points[0].x;
        let lastPointIndex = points[points.length - 1].x;

        let afterFirstPointIndex = Math.round(firstPointIndex + (lastPointIndex - firstPointIndex) / 2);
        afterFirstPointIndex = afterFirstPointIndex < lastPointIndex - 10 ? afterFirstPointIndex : lastPointIndex - 10;
        this._setExtremes(afterFirstPointIndex, lastPointIndex);
    };

    zoomOut() {
        let chart = this.chartComponent.current.chart;
        let mainSeries = chart.get('main');
        let extremes = chart.get('main-xaxis').getExtremes();
        let points = mainSeries.points;
        let firstPointIndex = points[0].x;
        let firstPointMargin = points.length - extremes.userMin + extremes.dataMin;
        firstPointMargin = firstPointMargin > 0 ? firstPointMargin : 0;
        let lastPointIndex = Math.min(points[points.length - 1].x + firstPointMargin, extremes.dataMax);
        let afterFirstPointIndex = firstPointIndex - points.length > extremes.dataMin ? firstPointIndex - points.length : extremes.dataMin;
        this._setExtremes(afterFirstPointIndex, lastPointIndex);
    };

    render() {
        return <div style={{position: 'relative', width: '100%', height: '100%'}}>

            { !this.props.isMobile ?
                <div id="util_wrapper" style={{position: 'absolute', bottom: '25%', left: 'calc(50% - 41px)', zIndex: 3}}>
                    <button onClick={() => this.zoomIn()} style={{width: '40px', height: '36px', border: '0 none', backgroundColor: '#333', borderRadius: '3px', cursor: 'pointer', opacity: 0.25, color: '#fff', fontSize: '1.3em', fontWeight: 'bold', marginRight: '2px'}}>+</button>
                    <button onClick={() => this.zoomOut()} style={{width: '40px', height: '36px', border: '0 none', backgroundColor: '#333', borderRadius: '3px', cursor: 'pointer', opacity: 0.25, color: '#fff', fontSize: '1.3em', fontWeight: 'bold'}}>-</button>
                </div>
                : undefined
            }
            <Realtime {...this.props.realtime} code={this.state.code} callback={(quotes) => this.insertQuotes(quotes)}>
                <HighchartsReact
                    ref={this.chartComponent}
                    highcharts={Highcharts}
                    constructorType={'stockChart'}
                    options={this.highchartsOptions}
                />
            </Realtime>
        </div>;
    };
}

export default WebChartReact;